// constants
const RAINFALL = "scenarioTwo/RAINFALL";
const SLR = "scenarioTwo/SLR";
const SURGE = "scenarioTwo/SURGE";
const GROUNDWATER = "scenarioTwo/GROUNDWATER";
const ADAPTATION = "scenarioTwo/ADAPTATION";

// actions
const getRain = (option) => {
 return {
  type: RAINFALL,
  option,
 };
};

const getSLR = (option) => {
 return {
  type: SLR,
  option,
 };
};

const getSurge = (option) => {
 return {
  type: SURGE,
  option,
 };
};

const getGroundwater = (option) => {
 return {
  type: GROUNDWATER,
  option,
 };
};

const getAdaptation = (option) => {
 return {
  type: ADAPTATION,
  option,
 };
};

// thunks
export const getRainfallAmount2 = (option) => async (dispatch) => {
 try {
  dispatch(getRain(option));
 } catch (error) {
  return error.message;
 }
};
export const getSeaLevelRise2 = (option) => async (dispatch) => {
 try {
  dispatch(getSLR(option));
 } catch (error) {
  return error.message;
 }
};

export const getStormSurge2 = (option) => async (dispatch) => {
 try {
  dispatch(getSurge(option));
 } catch (error) {
  return error.message;
 }
};
export const getGroundwaterCondition2 = (option) => async (dispatch) => {
 try {
  dispatch(getGroundwater(option));
 } catch (error) {
  return error.message;
 }
};
export const getAdaptationScenario2 = (option) => async (dispatch) => {
 try {
  dispatch(getAdaptation(option));
 } catch (error) {
  return error.message;
 }
};

// initial state
const initialState = {
 scenarioTwo: {},
};

// reducer function
const scenarioTwoReducer = (state = initialState, action) => {
 let newState;
 switch (action.type) {
  case ADAPTATION:
   newState = { ...state };
   newState.scenarioTwo["adaptation"] = {};
   newState.scenarioTwo["adaptation"] = action.option;
   if (!!newState.scenarioTwo["slr"]) delete newState.scenarioTwo["slr"];
   if (!!newState.scenarioTwo["rainfall"])
    delete newState.scenarioTwo["rainfall"];
   if (newState.scenarioTwo["surge"]) delete newState.scenarioTwo["surge"];
   if (newState.scenarioTwo["groundwater"])
    delete newState.scenarioTwo["groundwater"];
   return newState;
  case SLR:
   newState = { ...state };
   newState.scenarioTwo["slr"] = {};
   newState.scenarioTwo["slr"] = action.option;
   if (!!newState.scenarioTwo["rainfall"])
    delete newState.scenarioTwo["rainfall"];
   if (newState.scenarioTwo["surge"]) delete newState.scenarioTwo["surge"];
   if (newState.scenarioTwo["groundwater"])
    delete newState.scenarioTwo["groundwater"];
   return newState;
  case RAINFALL:
   newState = { ...state };
   newState.scenarioTwo["rainfall"] = {};
   newState.scenarioTwo["rainfall"] = action.option;
   if (!!newState.scenarioTwo["surge"]) delete newState.scenarioTwo["surge"];
   if (!!newState.scenarioTwo["groundwater"])
    delete newState.scenarioTwo["groundwater"];
   return newState;
  case SURGE:
   newState = { ...state };
   newState.scenarioTwo["surge"] = {};
   newState.scenarioTwo["surge"] = action.option;
   if (newState.scenarioTwo["groundwater"])
    delete newState.scenarioTwo["groundwater"];
   return newState;
  case GROUNDWATER:
   newState = { ...state };
   newState.scenarioTwo["groundwater"] = {};
   newState.scenarioTwo["groundwater"] = action.option;
   return newState;
  // case ADAPTATION:
  //   newState = { ...state };
  //   newState.scenarioTwo["adaptation"] = {};
  //   newState.scenarioTwo["adaptation"] = action.option;
  //   return newState;
  default:
   return state;
 }
};

export default scenarioTwoReducer;
